// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3731":"17d2535a","8484":"c2490085","9049":"b0d61871"}[chunkId] + ".chunk.css";
};